let mcSubmitted = false;

// Attach event listeners to the form
const form = document.querySelector('#mc-embedded-subscribe-form');
if (form) {
    form.addEventListener('submit', function (event) {
        mcSubmitted = true;
    });

    const emailInput = form.querySelector('.mc-field__email');
    emailInput && emailInput.addEventListener('change', () => {
        // We use setTimeout to get the latest state of the input data. Without it, we get old data
        setTimeout(() => {
            if (emailInput.getAttribute('aria-invalid') === 'true') {
                emailInput.setAttribute('aria-describedby', 'email-error-msg');
            } else {
                emailInput.removeAttribute('aria-describedby');
            }
        }, 0);
    })

    form.addEventListener('reset', function (event) {
        if (mcSubmitted) {
            // Hide the success message
            const successResponse = document.querySelector('#mce-success-response');
            if (successResponse) {
                successResponse.style.display = "none";
            }

            // Newsletter datalayer code
            let newsletterFormType = 'Newsletter';
            if (theme.settings.newsletterTemplate === 'true') {
                newsletterFormType = 'Newsletter SignupPage';
            }
            dataLayer.push({
                'event': 'gaEvent',
                'eventTrigger': 'Newsletter',
                'eventCategory': 'Form',
                'eventAction': 'Submit',
                'eventLabel': newsletterFormType,
                'eventValue': undefined
            });

            // Check if there is a thank you page link
            if (theme.settings.newsletterTemplate === 'true' && theme.settings.thankyou_page_url) {
                window.location.href = theme.settings.thankyou_page_url;
            } else {
                const thanksMessage = document.querySelector('#mc-thanks-msg');
                if (thanksMessage) {
                    thanksMessage.style.display = "block";
                }
            }
        }
    });
}

//DWFT-5604 task functionality goes here
document.addEventListener("DOMContentLoaded", function () {
    const dobInput = document.getElementById("mc-DOB--newsletter");
    const errorDiv = document.getElementById("mc-dob-error");
    // Set max to today to disable future dates in picker
    const today = new Date().toISOString().split("T")[0];
    dobInput.max = today;
    dobInput.min = "1900-01-01";

    // Validation on change or form submission
    dobInput.addEventListener("change", validateDOB);
    dobInput.addEventListener("blur", validateDOB);

    function validateDOB() {
      const value = dobInput.value;
      if (!value) {
        errorDiv.style.display = "none";
        dobInput.setCustomValidity("");
        return true;
      }
      errorDiv.style.display = "none";
      dobInput.setCustomValidity("");

      const dateRegex = /^\d{4}-\d{2}-\d{2}$/; 
      if (!dateRegex.test(value)) {
        errorDiv.style.display = "block";
        return false;
      }

      const selectedDate = new Date(value);
      const now = new Date();
      const minDate = new Date("1900-01-01");

      if (selectedDate > now) {
        errorDiv.textContent = dob_future_date;
        errorDiv.style.display = "block";
        dobInput.setCustomValidity(dob_future_date);
        return false;
      }

      if (selectedDate < minDate) {
        errorDiv.textContent = dob_before_date;
        errorDiv.style.display = "block";
        dobInput.setCustomValidity(dob_before_date);
        return false;
      }

      // Clear errors if valid
      dobInput.setCustomValidity("");
      errorDiv.style.display = "none";
      return true;
    }

    //Data syncing to mailchimp fields
    const dobField = document.getElementById("mc-DOB--newsletter");
    const dayField = document.getElementById("mce-BIRTHD-day");
    const monthField = document.getElementById("mce-BIRTHD-month");
    const yearField = document.getElementById("mce-BIRTHD-year");
    const dayFieldBday = document.getElementById("mce-BDAY-day");
    const monthFieldBday = document.getElementById("mce-BDAY-month");

    dobField.addEventListener("change", function () {
        const selectedDate = this.value; 
        if (selectedDate) {
            const [year, month, day] = selectedDate.split("-");

            dayField.value = day.padStart(2, '0');
            monthField.value = month.padStart(2, '0');
            yearField.value = year;
            dayFieldBday.value = day.padStart(2, '0');
            monthFieldBday.value = month.padStart(2, '0');
        } else {
            // Clear fields if no date selected
            dayField.value = "";
            monthField.value = "";
            yearField.value = "";
            dayFieldBday.value = "";
            monthFieldBday.value = "";
        }
    });
});